import Vue from "vue";
import Router from "vue-router";
const index = () => import("./views/index.vue");//主页
const wenBrigade = () => import("./views/WenBrigade.vue");//智慧文旅
const agricultural = () => import("./views/agricultural.vue");//智慧农业
const security = () => import("./views/security.vue");//智慧政务
const aboutus = () => import("./views/aboutus.vue");//关于我们

Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "index",
      component: index
    },
    {
      path: "/wenBrigade",
      name: "wenBrigade",
      component: wenBrigade
    },
    {
      path: "/agricultural",
      name: "agricultural",
      component: agricultural
    },
    {
      path: "/security",
      name: "security",
      component: security
    },
    {
      path: "/aboutus",
      name: "aboutus",
      component: aboutus
    },


  ]
});

// router.beforeEach((to, from, next) => {
//   if (wxlist.lastIndexOf(to.name) == -1) {
//     if (getToken()) {
//       next()
//     } else {
//       next("/?redirect=" + to.path)
//     }
//   } else {
//     next()
//   }
// })
export default router;